import * as React from 'react';
import { styled, useTheme } from '@mui/material/styles';
import Box from '@mui/material/Box';
import Drawer from '@mui/material/Drawer';
import CssBaseline from '@mui/material/CssBaseline';
import MuiAppBar from '@mui/material/AppBar';
import Toolbar from '@mui/material/Toolbar';
import List from '@mui/material/List';
import Typography from '@mui/material/Typography';
import Divider from '@mui/material/Divider';
import IconButton from '@mui/material/IconButton';
import MenuIcon from '@mui/icons-material/Menu';
import ChevronRightIcon from '@mui/icons-material/ChevronRight';
import ListItem from '@mui/material/ListItem';
import ListItemButton from '@mui/material/ListItemButton';
import ListItemIcon from '@mui/material/ListItemIcon';
import ListItemText from '@mui/material/ListItemText';
import CloseIcon from '@mui/icons-material/Close';
import DashboardCustomizeRoundedIcon from '@mui/icons-material/DashboardCustomizeRounded';
import StorefrontIcon from '@mui/icons-material/Storefront';
import Inventory2OutlinedIcon from '@mui/icons-material/Inventory2Outlined';
import PeopleAltIcon from '@mui/icons-material/PeopleAlt';
import LogoutRoundedIcon from '@mui/icons-material/LogoutRounded';
import { Container } from '@mui/system';
import { Grid } from '@mui/material';
import sidebar from "../../css/seller/Sidebar.module.css"
import { useCookies } from 'react-cookie';
import { useNavigate } from 'react-router';



const drawerWidth = 320;

const Main = styled('main', { shouldForwardProp: (prop) => prop !== 'open' })(
    ({ theme, open }) => ({
        flexGrow: 1,
        padding: theme.spacing(3),
        transition: theme.transitions.create('margin', {
            easing: theme.transitions.easing.sharp,
            duration: theme.transitions.duration.leavingScreen,
        }),
        marginLeft: `-${drawerWidth}px`,
        ...(open && {
            transition: theme.transitions.create('margin', {
                easing: theme.transitions.easing.easeOut,
                duration: theme.transitions.duration.enteringScreen,
            }),
            marginLeft: 0,
        }),
    }),
);

const AppBar = styled(MuiAppBar, {
    shouldForwardProp: (prop) => prop !== 'open',
})(({ theme, open }) => ({
    transition: theme.transitions.create(['margin', 'width'], {
        easing: theme.transitions.easing.sharp,
        duration: theme.transitions.duration.leavingScreen,
    }),
    ...(open && {
        width: `calc(100% - ${drawerWidth}px)`,
        marginLeft: `${drawerWidth}px`,
        transition: theme.transitions.create(['margin', 'width'], {
            easing: theme.transitions.easing.easeOut,
            duration: theme.transitions.duration.enteringScreen,
        }),
    }),
}));

const DrawerHeader = styled('div')(({ theme }) => ({
    display: 'flex',
    alignItems: 'center',
    padding: theme.spacing(0, 1),
    // necessary for content to be below app bar
    ...theme.mixins.toolbar,
    justifyContent: 'space-between',
    height: '90px',
}));

export default function SidebarAdmin({ components, titleAppBar }) {
    const [cookies, setCookie] = useCookies(['accessToken']);
    const theme = useTheme();
    const [open, setOpen] = React.useState(false);
    const [user, setUser] = React.useState({});
    const navigate = useNavigate();
    const handleDrawerOpen = () => {
        setOpen(true);
    };

    const handleDrawerClose = () => {
        setOpen(false);
    };

    const logoItems = [
        <DashboardCustomizeRoundedIcon className={sidebar.sizeIcons} />, <StorefrontIcon className={sidebar.sizeIcons} />, <Inventory2OutlinedIcon className={sidebar.sizeIcons} />,
        <PeopleAltIcon className={sidebar.sizeIcons} />, <LogoutRoundedIcon className={sidebar.sizeIcons} />]
    let numLogo = 0

    React.useEffect(() => {
        const validateAccessToken = async () => {
            try {
                const url = 'https://w-shop-backend.vercel.app/api/auth/whoami';
                const rawResponse = await fetch(url, {
                    method: 'GET',
                    headers: {
                        'Content-type': 'application/json',
                        'Authorization': 'Bearer ' + cookies.accessToken,
                    },
                })
                const response = await rawResponse.json();
                if (response.status !== 'success') {
                    throw new Error();
                } else {
                    setUser(response.data);
                }
            } catch (error) {
                setCookie('accessToken', '', { path: '/' });
                navigate('/');
            }
        }
        if (cookies.accessToken === '') {
            navigate('/');
        } else {
            validateAccessToken();
        }
    }, [cookies.accessToken, setCookie, navigate])

    return (
        <Box sx={{ display: 'flex', boxSizing: 'none', marginTop: '-25px' }}>
            <CssBaseline />
            <AppBar position="fixed" open={open} sx={{ background: 'white', color: "rgba(0, 102, 255, 0.45)", fontFamily: "alice", fontSize: "38px", height: 95, paddingTop: "15px" }}>
                <Container maxWidth='100%'>
                    <Grid container spacing={2} justifyContent='space-between'>
                        <Grid item>
                            <Toolbar>
                                <IconButton
                                    color="inherit"
                                    aria-label="open drawer"
                                    onClick={handleDrawerOpen}
                                    edge="start"
                                    sx={{ mr: 2, ...(open && { display: 'none' }) }}
                                >
                                    <MenuIcon sx={{ color: "dodgerblue" }} />
                                </IconButton>
                                <h1 className=' d-none d-md-block'>{titleAppBar}</h1>
                            </Toolbar>
                        </Grid>
                        <Grid item >
                            <Toolbar>
                                {/* <img alt='' src='img/notificationBlue.png' width={25} height={25} className='  me-md-5' style={{...(open && { display: 'none' })}}/> */}
                                <div className=' d-none d-lg-flex me-3'>
                                    <img src={user.imgUrl} width={35} height={35} alt="" style={{ borderRadius: "50px" }} />
                                    <Typography
                                        sx={{
                                            fontFamily: 'Montserrat',
                                            fontStyle: 'normal',
                                            fontWeight: '500',
                                            fontSize: '20px',
                                            lineHeight: '24px',
                                            color: '#484848',
                                            marginLeft: '10px'
                                        }}
                                    >{user.name}</Typography>
                                </div>
                            </Toolbar>
                        </Grid>
                    </Grid>
                </Container>
            </AppBar>
            <Drawer
                sx={{
                    width: drawerWidth,
                    flexShrink: 0,
                    '& .MuiDrawer-paper': {
                        width: drawerWidth,
                        boxSizing: 'border-box',
                        backgroundColor: 'rgba(0, 102, 255, 0.45)',
                        paddingLeft: '15px',
                        paddingRight: '15px'
                    },
                }}
                variant="persistent"
                anchor="left"
                open={open}
            >
                <DrawerHeader sx={{ paddingRight: '0px', maxHeight: '14px', marginTop: '15px' }}>
                    <img alt='' src='/img/logo.png' className={sidebar.logo} />
                    <h1 className={sidebar.titleLogo}>W-Shop</h1>
                    <IconButton onClick={handleDrawerClose}>
                        {theme.direction === 'ltr' ? <CloseIcon sx={{ color: "white" }} /> : <ChevronRightIcon />}
                    </IconButton>
                </DrawerHeader>
                <hr sx={{ margin: '0px' }}></hr>
                <Divider sx={{ backgroundColor: "white" }} />
                <List sx={{ marginTop: '1', }}>
                    {
                        [{ "name": 'Dashboard', 'link': '/adminDashboard' }, { "name": 'Toko', 'link': '/adminToko' }, { "name": 'Produk', 'link': '/adminProduk' }, { "name": 'User', 'link': '/adminUser' }, { "name": 'Logout', 'link': '/logout' }].map((text, index) => (
                            <ListItem key={text.name} disablePadding >
                                <a data-testid={`sidebar-${text.name}`} href={text.link} style={{ textDecoration: 'none' }}>
                                    <ListItemButton sx={{ height: '90px', width: '300px' }}>
                                        <ListItemIcon sx={{ color: 'white' }}>
                                            {
                                                index === numLogo ? logoItems[numLogo++] : <StorefrontIcon sx={{ fontSize: '45px' }} />

                                            }
                                        </ListItemIcon>
                                        <ListItemText>
                                            <p style={{
                                                fontFamily: 'Montserrat',
                                                fontStyle: 'normal',
                                                fontWeight: '700',
                                                fontSize: '24px',
                                                lineHeight: '37px',
                                                color: '#FFFFFF',
                                                paddingTop: "15px"
                                            }}>{text.name}</p>
                                        </ListItemText>
                                    </ListItemButton>
                                </a>
                            </ListItem>
                        ))}
                </List>
                <Divider />
            </Drawer>
            <Main open={open} sx={{ backgroundColor: '#F1F1F1' }}>
                <DrawerHeader />
                {components}
            </Main>
        </Box>
    );
}
